import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import BasicInstallation from "./BasicInstallation";
import PostInstallationTable from "./PostInstallationTable";
import SecondBasicInstallation from "./SecondBasicInstallation";
import DynamicTables from "./DynamicTables";
import FinalField from "./FinalField";
import moment from "moment";
import { DocumentText1 } from "iconsax-react";
import { useLoader } from "../../Loader";

function InstallationCertification(props) {
  const [formData, setFormData] = useState({
    plantLocation: "",
    shippingLocation: "",
    equipmentName: "",
    brand: "",
    equipmentCount: "",
    cerNumber: "",
    supplierName: "",
    poNumber: "",
    poDate: "",
    poValue: "",
    asset_code_no: "",
    engineeringCode: "",
  });

  const [checklistData, setChecklistData] = useState([
    {
      parameter: "Asset addition documentation complete",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Operator care training completed",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Preventive maintenance plan documented",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Operation and maintenance manual",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Machine updated in Maintenance software",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Calibration records uploaded",
      conclusion: "",
      remarks: "",
      signature: "",
    },
  ]);

  const [saftyChecklistData, setsaftyChecklistData] = useState([
    {
      parameter: "Electrical connection",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Safety guard in place",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Equipment noise level/protection meet OSHA requirements",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "PPE available",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Emergency shutdown process in place",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "List of equipment for statutory inspection",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Inspection from chartered engineer",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Electrical and mechanical working",
      conclusion: "",
      remarks: "",
      signature: "",
    },
    {
      parameter: "Emergency signage visible and clear",
      conclusion: "",
      remarks: "",
      signature: "",
    },
  ]);

  const [trialReportData, setTrialReportData] = useState({
    trialReport: "",
    dateOfCompletionOfTrialRun: "",
    assetsTagNo: "",
    dateOfCommencementOfProduction: "",
    specialBenefits: "",
  });

  const [invoice, setinvoice] = useState([
    {
      supplierName: "",
      billNo: "",
      date: "",
      qty: "",
      value: "",
    },
  ]);

  const [docBooking, setdocBooking] = useState([
    {
      no: "",
      date: "",
      itemDesc: "",
      basic: "",
      bedAdhoc: "",
      igst: "",
      sgst: "",
      cgst: "",
      capValue: "",
    },
  ]);

  const [finalData, setFinalData] = useState({
    usefulLife: "",
    coaDescription: "",
    scheduleVIClassification: "",
    depreciationRate: "",
    companiesAct: "",
    incomeTaxAct: "",
    capitalisationEntryNo: "",
    capitalisationEntryDate: "",
    farSerialNo: "",
  });

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [fileUpload, setFileUpload] = useState("");
  const { startLoader, stopLoader } = useLoader();
  const [isDisable, setIsDisable] = useState(false);
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      startLoader();
      const postInstallationList = checklistData.map((item, index) => ({
        id: item.id ? item?.id : 0,
        particulars: item.parameter,
        conclusion_check_list: item.conclusion,
        remark: item.remarks,
        signature: item.signature,
      }));

      const safetyPostInstallationList = saftyChecklistData.map(
        (item, index) => ({
          id: item.id ? item?.id : 0,
          particulars: item.parameter,
          conclusion_check_list: item.conclusion,
          remark: item.remarks,
          signature: item.signature,
        })
      );
      const invoiceDetails = invoice.map((item, index) => ({
        id: item.id ? item?.id : 0,
        supplier_name: item.supplierName,
        bill_no: item.billNo,
        date: item.date ? moment(item.date).format("YYYY-MM-DD") : "",
        qty: item.qty,
        amount: item.value,
      }));

      const srBookingDetail = docBooking.map((item, index) => ({
        id: item.id ? item?.id : 0,
        date: item.date ? moment(item.date).format("YYYY-MM-DD") : "",
        item_description: item.itemDesc,
        basic: item.basic,
        bed: item.bedAdhoc,
        igst: item.igst,
        sgst: item.sgst,
        cgst: item.cgst,
        capitalisation_value: item.capValue,
      }));

      var bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props?.rowData?.id);
      }

      bodyFormData.append("invert_id", props?.invertId);
      bodyFormData.append("plant_id", formData.plantLocation);
      bodyFormData.append("location_id", formData.shippingLocation);
      bodyFormData.append("equipment_name", formData.equipmentName);
      bodyFormData.append("equipment_no", formData.equipmentCount);
      bodyFormData.append("brand", formData.brand);
      bodyFormData.append("cer_no", formData.cerNumber);
      bodyFormData.append("supplier_name", formData.supplierName);
      bodyFormData.append("po_no", formData.poNumber);
      bodyFormData.append(
        "po_date",
        moment(formData.poDate).format("YYYY-MM-DD")
      );
      bodyFormData.append("po_value", formData.poValue);
      bodyFormData.append("asset_code_no", formData.asset_code_no);
      bodyFormData.append("engineering_group_code", formData.engineeringCode);
      bodyFormData.append("trial_report", trialReportData.trialReport);
      bodyFormData.append(
        "trial_completion_date",
        trialReportData.dateOfCompletionOfTrialRun
          ? moment(trialReportData.dateOfCompletionOfTrialRun).format(
              "YYYY-MM-DD"
            )
          : ""
      );
      bodyFormData.append("asset_tag_no", trialReportData.assetsTagNo);
      bodyFormData.append(
        "production_capitalisation_date",
        trialReportData.dateOfCommencementOfProduction
          ? moment(trialReportData.dateOfCommencementOfProduction).format(
              "YYYY-MM-DD"
            )
          : ""
      );
      bodyFormData.append(
        "benefits_classification_category",
        trialReportData.specialBenefits
      );
      bodyFormData.append("useful_life_assets", finalData.usefulLife);
      bodyFormData.append("COA_description", finalData.coaDescription);
      bodyFormData.append(
        "schedule_classification",
        finalData.scheduleVIClassification
      );
      bodyFormData.append("depraciation_rate", finalData.depreciationRate);
      bodyFormData.append("companies_act", finalData.companiesAct);
      bodyFormData.append("income_tax_act", finalData.incomeTaxAct);
      bodyFormData.append(
        "capitalistion_entry_no",
        finalData.capitalisationEntryNo
      );
      bodyFormData.append(
        "capitalistion_date",
        finalData.capitalisationEntryDate
          ? moment(finalData.capitalisationEntryDate).format("YYYY-MM-DD")
          : ""
      );
      bodyFormData.append("FAR_serial_no", finalData.farSerialNo);
      bodyFormData.append(
        "post_installation_list",
        JSON.stringify(postInstallationList)
      );
      bodyFormData.append(
        "safety_post_installation",
        JSON.stringify(safetyPostInstallationList)
      );
      bodyFormData.append("invoice_details", JSON.stringify(invoiceDetails));
      bodyFormData.append("sr_booking_detail", JSON.stringify(srBookingDetail));
      bodyFormData.append("install_attach", fileUpload);

      utils
        .callAPI("post", `/installation/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            stopLoader();
          }
          stopLoader();
          setIsSubmit(false);
        })
        .catch((err) => {
          stopLoader();
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    setFileUpload(file);
  };
  console.log("props", props?.invertId);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      console.log(props.rowData);
      const {
        plant_id,
        location_id,
        equipment_name,
        equipment_no,
        brand,
        cer_no,
        supplier_name,
        po_no,
        po_date,
        po_value,
        asset_code_no,
        engineering_group_code,
        trial_report,
        trial_completion_date,
        asset_tag_no,
        production_capitalisation_date,
        benefits_classification_category,
        useful_life_assets,
        COA_description,
        schedule_classification,
        depraciation_rate,
        companies_act,
        income_tax_act,
        capitalistion_entry_no,
        capitalistion_date,
        FAR_serial_no,
        attechPath,
        post_installation,
        safety_installation,
        invoice_data,
        sr_booking,
      } = props.rowData;
      const parseDate = (date) => {
        return date && date !== "0000-00-00" ? new Date(date) : null;
      };

      setFormData({
        plantLocation: plant_id,
        shippingLocation: location_id,
        equipmentName: equipment_name,
        equipmentCount: equipment_no,
        brand,
        cerNumber: cer_no,
        supplierName: supplier_name,
        poNumber: po_no,
        poDate: parseDate(po_date),
        poValue: po_value,
        asset_code_no: asset_code_no,
        engineeringCode: engineering_group_code,
      });

      setTrialReportData({
        trialReport: trial_report,
        dateOfCompletionOfTrialRun: parseDate(trial_completion_date),
        assetsTagNo: asset_tag_no,
        dateOfCommencementOfProduction: parseDate(
          production_capitalisation_date
        ),
        specialBenefits: benefits_classification_category,
      });

      setFinalData({
        usefulLife: useful_life_assets,
        coaDescription: COA_description,
        scheduleVIClassification: schedule_classification,
        depreciationRate: depraciation_rate,
        companiesAct: companies_act,
        incomeTaxAct: income_tax_act,
        capitalisationEntryNo: capitalistion_entry_no,
        capitalisationEntryDate: parseDate(capitalistion_date),
        farSerialNo: FAR_serial_no,
      });

      if (post_installation) {
        setChecklistData(
          post_installation.map((item) => ({
            id: item.id,
            parameter: item.particulars || "",
            conclusion: item.conclusion_check_list || "",
            remarks: item.remark || "",
            signature: item.signature || "",
          }))
        );
      }

      if (safety_installation) {
        setsaftyChecklistData(
          safety_installation.map((item) => ({
            id: item.id,
            parameter: item.particulars || "",
            conclusion: item.conclusion_check_list || "",
            remarks: item.remark || "",
            signature: item.signature || "",
          }))
        );
      }

      if (invoice_data) {
        setinvoice(
          invoice_data.map((item) => ({
            id: item.id,
            supplierName: item.supplier_name || "",
            billNo: item.bill_no || "",
            date:  parseDate(item.date),
            qty: item.qty || "",
            value: item.amount || "",
          }))
        );
      }

      if (sr_booking) {
        setdocBooking(
          sr_booking.map((item) => ({
            id: item.id,
            no: item.id || "",
            date:  parseDate(item.date),
            itemDesc: item.item_description || "",
            basic: item.basic || "",
            bedAdhoc: item.bed || "",
            igst: item.igst || "",
            sgst: item.sgst || "",
            cgst: item.cgst || "",
            capValue: item.capitalisation_value || "",
          }))
        );
      }

      setFileUpload(attechPath || "");

      setIsEdit(true);
    }
  }, [props.rowData]);

  useEffect(() => {
    if (
      userProfile &&
      userProfile?.user_role[0]?.roleName === "Finance Manager" &&
      props.rowData &&
      Object.keys(props.rowData).length > 0
    ) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [userProfile, props.rowData]);

  return (
    <>
      <div className="section-body ">
        <RB.Card className="">
          <RB.Card.Header>
            <h4>Installation Certification</h4>
            <div className="card-header-action">
              <Link
                className="btn btn-underline me-2"
                onClick={handleBackClick}
              >
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
              <RB.Row>
                <BasicInstallation
                  formData={formData}
                  setFormData={setFormData}
                  isDisable={isDisable}
                />
                <PostInstallationTable
                  checklistData={checklistData}
                  setChecklistData={setChecklistData}
                  saftyChecklistData={saftyChecklistData}
                  setsaftyChecklistData={setsaftyChecklistData}
                  isDisable={isDisable}
                />
                <SecondBasicInstallation
                  trialReportData={trialReportData}
                  isDisable={isDisable}
                  setTrialReportData={setTrialReportData}
                />
                <DynamicTables
                  invoice={invoice}
                  setinvoice={setinvoice}
                  docBooking={docBooking}
                  isDisable={isDisable}
                  setdocBooking={setdocBooking}
                />
                <FinalField
                  finalData={finalData}
                  setFinalData={setFinalData}
                  isDisable={isDisable}
                />

                <div className="mb-3">
                  <label className="form-label">Asset Snap</label>
                  <div className="d-flex align-items-center">
                    <RB.Form.Control
                      type="file"
                      name="quotation"
                      onChange={handleFileUpload}
                      accept=".jpg,.jpeg,.png"
                      disabled={isDisable}
                      required={!isEdit}
                      className="me-2 flex-grow-1"
                    />
                    {isEdit && fileUpload && (
                      <a
                        href={props.rowData.attechPath}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link p-0"
                        title="View Current AttechMent"
                      >
                        <DocumentText1 />
                      </a>
                    )}
                  </div>
                </div>
              </RB.Row>
              <RB.Row className="justify-content-start mt-3">
                <RB.Col className="col-auto">
                  <RB.Button variant="primary" type="submit">
                    Submit
                  </RB.Button>
                </RB.Col>
              </RB.Row>
            </RB.Form>
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default InstallationCertification;
